"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERTICALS = void 0;
exports.VERTICALS = [
    'covid',
    'dermatologist',
    'ear-nose-throat',
    'eye-doctor',
    'general',
    'gynecologist',
    'mental-health',
    'pediatrician',
    'physical',
    'psychology',
    'specialist',
];
